import React from "react";
import { Container, Row, Col} from "react-bootstrap";
import './PartnerAuthorized.css';
function PartnerAuthorized(){
    return(
        <>
            <section className="authorized-sc">
                <Container>
                    <Row>
                        <Col xl={12}>
                            <div className="authorized-pnl">
                                <h2>Who is an Authorised person?</h2>
                                <p>According to the SEBI, an authorised person (AP) can be an individual, a limited liability partnership (LLP), or a partnership firm with whom a stockbroker has decided to conduct business. It is their responsibility as the stockbroker's agent to ensure that traders have access to the trading platform. Because they engage directly with traders, designated individuals (AP) have a significant role in boosting the volume of deals. </p>
                                <p>Share trading and investing have grown appealing due to the compounding returns they provide. As the number of brokers is minimal in comparison to the number of investors, authorised individuals (also known as Sub Brokers) handle much of the job of investing.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default PartnerAuthorized;